var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelperCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52526 11.0002L0.5 18.875L3.125 21.5L11.0001 13.475L18.875 21.5L21.5 18.875L13.475 11.0002L21.5 3.125L18.875 0.5L11.0001 8.52529L3.125 0.5L0.5 3.125L8.52526 11.0002Z",
    fill: "#1A4CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelperCloseIcon);
export default __webpack_public_path__ + "static/media/helperCloseIcon.bc7b0e45d025e66267085a73d20e1af5.svg";
export { ForwardRef as ReactComponent };